<div class="va-nav-item-list">
  <div class="submenu-trigger" (click)="toggleOpen()" [ngClass]="{ 'menu-open': isOpen }">
    <mat-icon class="arrow-icon">arrow_right</mat-icon>
    <button class="nav-button" mat-button>
      <!-- needs to support custom icon too -->
      @if (icon && !isSvg) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (icon && isSvg) {
        <mat-icon [svgIcon]="icon" />
      }
      <span class="truncate">{{ label }}</span>
    </button>
  </div>
  <div class="submenu" [ngClass]="{ 'menu-open': isOpen }">
    <div #submenu class="submenu-items">
      <ng-content />
    </div>
  </div>
</div>
